import { api, LiveChannelRegion } from '@setplex/tria-api'
import { attach, createStore, StoreWritable } from 'effector'
import { produce } from 'immer'
import { T } from '~/shared/helpers'

export const getAllLiveRegionsFx = attach({
  effect: api.live.base.getLiveChannelsRegionsFx,
})

export const $totalRegions = createStore<number>(0).on(
  getAllLiveRegionsFx.doneData,
  (_, data) => data?.total ?? 0
)

export const $liveRegions: StoreWritable<LiveChannelRegion[] | null> =
  createStore<LiveChannelRegion[] | null>(null)
    .reset(getAllLiveRegionsFx, getAllLiveRegionsFx.fail)
    .on(getAllLiveRegionsFx.doneData, (_, got) => got)

export const $regionsAlphabeticallySorted = $liveRegions.map((regions = []) =>
  produce(regions, (draft) => {
    draft?.sort((a, b) => a.name.localeCompare(b.name))
  })
)

export const $isRegionsLoaded = createStore(false)
  .on(getAllLiveRegionsFx.finally, T)
  .reset(getAllLiveRegionsFx)
